import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from '@/App';
import { ToastProvider } from '@/components/ui/toast';
import '@/styles/globals.css';
import '@/styles/studio.css';
import '@/styles/workspaces.css';
import '@/styles/playground.css';
import '@/styles/playground-workbench.css';

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Could not find root element to mount to');
}

createRoot(rootElement).render(
  <StrictMode>
    <ToastProvider position="bottom-right">
      <App />
    </ToastProvider>
  </StrictMode>,
);
